import { useQuery } from '@tanstack/react-query';

import { searchBusinessEntity } from '~apis/business-entity';

import { BusinessEntityQueryKey } from './useBusinessEntityListQuery';

export function useBusinessEntitySearchQuery({
  companyId,
  searchParam,
}: {
  companyId: string;
  searchParam: string;
}) {
  return useQuery(
    BusinessEntityQueryKey.search({ companyId, searchParam }),
    () =>
      searchBusinessEntity({
        companyId,
        searchParam,
      }),
    {
      enabled: !!companyId && !!searchParam,
    },
  );
}
